import { Box, Typography, useTheme } from '@mui/material';

export interface LegendItem {
  color: string;
  label: string;
}

interface LegendProps {
  items: LegendItem[];
}

const Legend = ({ items }: LegendProps) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 2.5,
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: '8px',
        padding: '6px 16px',
        backgroundColor: theme.palette.background.default,
      }}
    >
      {items.map((item, index) => (
        <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}>
          <Box
            sx={{
              width: 12,
              height: 12,
              borderRadius: '3px',
              backgroundColor: item.color,
              flexShrink: 0,
              border: `1px solid ${theme.palette.divider}`,
            }}
          />
          <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.8rem' }}>
            {item.label}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default Legend;
